<template>
  <transition
    tag="div"
    name="slide"
  >
    <div
      v-if="term"
      class="position-absolute border-2 border-gray-400 d-flex
        flex-column w-100 bg-white text-gray-600 card my-3"
      style="z-index: 20"
    >
      <transition
        tag="div"
        name="slide"
      >
        <div v-if="researched.length > 0">
          <v-company-search-display
            v-for="(rcompany, index) in researched"
            :key="`id-${rcompany.name + index}`"
            :company="rcompany"
            @click.once="setCompany(rcompany)"
          />
        </div>
      </transition>
      <div
        class="researched-company research-last d-flex p-3 align-items-center fw-bold"
        @click="next"
      >
        Je ne trouve pas mon entreprise
      </div>
    </div>
  </transition>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui, routing } from '@/mixins';
import CompanySearchDisplay from './CompanySearchDisplay.vue';

export default {
  components: {
    'v-company-search-display': CompanySearchDisplay,
  },
  mixins: [ui, routing],
  computed: {
    ...mapGetters({
      researched: 'companies/get',
    }),
    term() { return this.$store.state.companies.term; },
  },
  methods: {
    async next() {
      await this.$store.dispatch('companies/clearCompany');
      this.ui_focusScreen(false);
      return this.$router.push('/client/account/companies/add/new');
    },
    async setCompany(rcompany) {
      await this.$store.dispatch('companies/clearCompany');
      await this.$store.dispatch('companies/resetTerm');
      await this.$store.dispatch('companies/clear');
      try {
        const { data: company } = await this.$store.dispatch('companies/getCompany', rcompany);
        await this.$store.dispatch('companies/setValueDeep', { company });
      } catch (err) {
        this.$store.dispatch('reporting/sendError', { err, currentPage: 'api-societe-info' });
      } finally {
        this.ui_focusScreen(false);
        this.$emit('company-selected');
        this.ui_showToast({ show: true, message: 'Entreprise sélectionnée' });
      }
    },
  },
};
</script>
<style scoped>
.researched-company:hover{
  cursor: pointer;
  background-color: #EDF4FD;
}
.researched-company:first-of-type{
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.research-last:last-of-type {
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
</style>
